// Smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', (e) => {
        const id = link.getAttribute('href').slice(1);
        const el = document.getElementById(id);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); }
      });
    });

    // Mobile nav toggle
    const navToggle = document.querySelector('.nav-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    if (navToggle && mobileNav) {
      navToggle.addEventListener('click', () => {
        const open = navToggle.getAttribute('aria-expanded') === 'true';
        navToggle.setAttribute('aria-expanded', String(!open));
        navToggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
        if (open) {
          mobileNav.setAttribute('hidden', '');
        } else {
          mobileNav.removeAttribute('hidden');
        }
      });
      mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
        navToggle.setAttribute('aria-expanded', 'false');
        navToggle.setAttribute('aria-label', 'Open menu');
        mobileNav.setAttribute('hidden', '');
      }));
    }

    // ====== Hexagon Scroll Reveal (sticky pin + scroll-driven stages) ======
    (function initHexScroll() {
      const section = document.querySelector('#scroll-hex');
      if (!section) return;
      const track = section.querySelector('.scroll-hex-track');
      const stages = Array.from(section.querySelectorAll('.stage'));
      const dots = Array.from(section.querySelectorAll('.stage-dot'));
      const vertices = Array.from(section.querySelectorAll('.hex-vertices .hex-dot'));
      const progressEl = section.querySelector('.progress-current');
      const root = document.documentElement;
      if (!track || !stages.length) return;

      const N = stages.length;          // 6 reasons
      const MIN = 1, MAX = N;
      let currentStage = 0;             // 0 = not yet set

      function setStage(n) {
        n = Math.max(MIN, Math.min(MAX, n | 0));
        if (n === currentStage) return;
        currentStage = n;
        stages.forEach(s => s.classList.toggle('is-active', s.dataset.stage === String(n)));
        dots.forEach(d => d.classList.toggle('is-active', d.dataset.jumpStage === String(n)));
        vertices.forEach(v => v.classList.toggle('is-active-vertex', v.dataset.vertex === String(n)));
        if (progressEl) progressEl.textContent = String(n).padStart(2, '0');
        section.classList.toggle('is-at-end', n === MAX);
        // Layer transition: stages 1-3 = mind (Layer A), 4-6 = body (Layer B)
        section.classList.toggle('is-body', n >= 4);
        var layerEl = section.querySelector('.hex-layer-text');
        if (layerEl) layerEl.textContent = n >= 4 ? 'Balance the body' : 'Clear the mind';
      }

      // Map scroll position within the tall track → progress 0..1 → rotation + active stage.
      function update() {
        const rect = track.getBoundingClientRect();
        const vh = window.innerHeight;
        const scrollable = rect.height - vh;
        let p = scrollable > 0 ? (-rect.top) / scrollable : 0;
        p = Math.max(0, Math.min(1, p));
        // Continuous roll — the hexagon turns one full revolution across the whole section.
        root.style.setProperty('--hex-rotation', (p * 360).toFixed(2) + 'deg');
        // Discrete stage band (1..N) — one reason per equal slice of the scroll.
        let n = Math.floor(p * N) + 1;
        if (n > MAX) n = MAX;
        setStage(n);
      }
      // Direct update — cheap (class toggles + one CSS var) and reliable across browsers.
      function onScroll() { update(); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // Dot navigation → smooth-scroll to the centre of that stage's band.
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          const rect = track.getBoundingClientRect();
          const scrollable = rect.height - window.innerHeight;
          const targetP = (idx + 0.5) / N;
          const targetY = window.scrollY + rect.top + targetP * scrollable;
          window.scrollTo({ top: targetY, behavior: 'smooth' });
        });
      });

      // Test hooks (compatible with prior carousel)
      window.__scrollHexSetStage = setStage;
      window.__scrollHexCurrent = () => currentStage;
      window.__scrollHexReady = true;

      root.style.setProperty('--hex-rotation', '0deg');
      setStage(1);
      update();
    })();

    // ====== Sticky Add-to-Cart Bar ======
    (function initStickyCart() {
      const cart = document.getElementById('sticky-cart');
      const heroBanner = document.querySelector('.hero-banner');
      const pricing = document.getElementById('pricing');
      if (!cart || !heroBanner) return;

      function update() {
        const heroBottom = heroBanner.getBoundingClientRect().bottom;
        const pricingTop = pricing ? pricing.getBoundingClientRect().top : Infinity;
        const vh = window.innerHeight;
        // Show after hero scrolled off-screen, hide once pricing section is in view
        const shouldShow = heroBottom < 80 && pricingTop > vh * 0.4;
        cart.classList.toggle('is-visible', shouldShow);
        cart.setAttribute('aria-hidden', String(!shouldShow));
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();

    // Use-case slider controls
    const railTrack = document.querySelector('.use-case-track');
    const prevBtn = document.querySelector('.rail-prev');
    const nextBtn = document.querySelector('.rail-next');
    if (railTrack && prevBtn && nextBtn) {
      const stepSize = () => {
        const card = railTrack.querySelector('.use-case-card');
        if (!card) return 360;
        const styles = getComputedStyle(railTrack);
        const gap = parseFloat(styles.columnGap || styles.gap || '24');
        return card.getBoundingClientRect().width + gap;
      };
      const updateButtons = () => {
        const max = railTrack.scrollWidth - railTrack.clientWidth - 2;
        prevBtn.disabled = railTrack.scrollLeft <= 2;
        nextBtn.disabled = railTrack.scrollLeft >= max;
      };
      prevBtn.addEventListener('click', () => railTrack.scrollBy({ left: -stepSize(), behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => railTrack.scrollBy({ left:  stepSize(), behavior: 'smooth' }));
      railTrack.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

// ===== Hexabiome PDP (gallery + variant) =====
(function(){
  var main=document.getElementById('pdpMainImg');
  if(main){
    document.querySelectorAll('.pdp-thumb').forEach(function(t){
      t.addEventListener('click',function(){
        document.querySelectorAll('.pdp-thumb').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active'); main.src=t.dataset.full;
      });
    });
  }
  var opts=document.querySelectorAll('.pdp-opt');
  if(opts.length){
    var atcPrice=document.querySelector('.pdp-atc-price');
    var priceNow=document.getElementById('pdpPrice');
    opts.forEach(function(o){
      o.addEventListener('click',function(){
        opts.forEach(function(x){x.classList.remove('is-selected');});
        o.classList.add('is-selected');
        var r=o.querySelector('input'); if(r) r.checked=true;
        var p=o.getAttribute('data-price');
        if(p){ if(atcPrice)atcPrice.textContent=p; if(priceNow)priceNow.textContent=p; }
      });
    });
  }
})();

/* ==== Cart drawer + AJAX purchase flow (v1.1 Cart Drawer rows 20-25) ==== */
(function(){
  var drawer=document.getElementById('hexaCartDrawer');
  if(!drawer) return;
  var body=drawer.querySelector('[data-cart-body]');
  var counts=document.querySelectorAll('.cart-count');

  function money(cents){ return '$'+(cents/100).toFixed(2); }

  function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.documentElement.classList.add('hexa-cart-lock'); }
  function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('hexa-cart-lock'); }
  window.hexaCartDrawer={open:open,close:close};

  drawer.addEventListener('click',function(e){ if(e.target.closest('[data-cart-close]')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });

  function render(cart){
    counts.forEach(function(c){ c.textContent=cart.item_count; });
    if(!cart.items.length){
      body.innerHTML='<div class="hexa-cart-empty"><p>Your cart is empty.</p><a href="/products/morning-clarity" class="btn-ghost">Explore Morning Clarity</a></div>';
      return;
    }
    var html='<ul class="hexa-cart-items" role="list">';
    cart.items.forEach(function(it,i){
      html+='<li class="hexa-cart-item" data-line="'+(i+1)+'">'
        +(it.image?'<img class="hexa-cart-thumb" src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2')+'" alt="" width="60" height="60">':'')
        +'<div class="hexa-cart-item-meta"><span class="hexa-cart-item-title">'+it.product_title+'</span>'
        +(it.selling_plan_allocation?'<span class="hexa-cart-item-plan">'+it.selling_plan_allocation.selling_plan.name+'</span>':'')
        +'<div class="hexa-cart-qty" data-qty><button type="button" data-qty-minus aria-label="Decrease quantity">−</button><span data-qty-value>'+it.quantity+'</span><button type="button" data-qty-plus aria-label="Increase quantity">+</button></div></div>'
        +'<div class="hexa-cart-item-price"><span>'+money(it.final_line_price)+'</span><button type="button" class="hexa-cart-remove" data-remove aria-label="Remove item">Remove</button></div></li>';
    });
    html+='</ul>';
    html+='<div class="hexa-cart-subtoggle" data-sub-toggle hidden><span>Switch to Subscribe &amp; Save — 10% off, shipping included</span></div>';
    html+='<footer class="hexa-cart-foot"><p class="hexa-cart-shipnote">Free shipping on subscriptions · $5 for one-time orders</p>'
      +'<div class="hexa-cart-subtotal"><span>Subtotal</span><span data-cart-subtotal>'+money(cart.total_price)+'</span></div>'
      +'<a href="/checkout" class="btn btn-primary hexa-cart-checkout">Checkout</a></footer>';
    body.innerHTML=html;
  }

  function refresh(openAfter){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ render(c); if(openAfter) open(); return c; });
  }

  function changeLine(line,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(render);
  }

  body.addEventListener('click',function(e){
    var item=e.target.closest('.hexa-cart-item'); if(!item) return;
    var line=parseInt(item.dataset.line,10);
    var qtyEl=item.querySelector('[data-qty-value]');
    var qty=qtyEl?parseInt(qtyEl.textContent,10):1;
    if(e.target.closest('[data-qty-plus]')) changeLine(line,qty+1);
    else if(e.target.closest('[data-qty-minus]')) changeLine(line,Math.max(0,qty-1));
    else if(e.target.closest('[data-remove]')) changeLine(line,0);
  });

  // header cart icon -> drawer (keeps /cart href as no-JS fallback)
  document.querySelectorAll('a.cart-btn[href="/cart"]').forEach(function(a){
    a.addEventListener('click',function(e){ e.preventDefault(); refresh(true); });
  });

  // PDP form -> AJAX add (/cart/add.js) -> open drawer
  var form=document.querySelector('form.pdp-form');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('.pdp-atc');
      if(btn) btn.classList.add('is-loading');
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)})
        .then(function(r){ if(!r.ok) return r.json().then(function(d){throw d;}); return r.json(); })
        .then(function(){ return refresh(true); })
        .catch(function(err){
          var msg=(err&&(err.description||err.message))||'Something went wrong.';
          var el=form.querySelector('.pdp-form-error');
          if(!el){ el=document.createElement('p'); el.className='pdp-form-error'; form.appendChild(el); }
          el.textContent=msg;
        })
        .finally(function(){ if(btn) btn.classList.remove('is-loading'); });
    });
  }
})();

/* ==== Scroll reveal — restrained fade-up, Restoration mood (round 1) ==== */
(function(){
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(!('IntersectionObserver' in window)) return;
  var sel='.prose-section .prose-narrow, .section-head, .learn-card, .learn-topic, .strain-profile, .about-teaser-card, .prose-checks li, .sci-axis, .sci-flow, .sci-ladder-list li, .diff-card';
  var targets=Array.prototype.filter.call(document.querySelectorAll(sel),function(t){
    return !t.closest('.scroll-hex-section') && !t.closest('.hero-banner');
  });
  if(!targets.length) return;
  targets.forEach(function(t){ t.classList.add('hexa-reveal'); });
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  },{threshold:0.1, rootMargin:'0px 0px -36px 0px'});
  targets.forEach(function(t){ io.observe(t); });
})();

/* ==== Learn: Browse All — search / category filter / load more (v1.1 rows 260-265) ==== */
(function(){
  var browse=document.querySelector('.learn-browse');
  if(!browse) return;
  var items=Array.prototype.slice.call(browse.querySelectorAll('.lb-item'));
  var search=browse.querySelector('.learn-search');
  var chips=browse.querySelectorAll('.lf-chip');
  var moreBtn=browse.querySelector('[data-load-more]');
  var emptyEl=browse.querySelector('.learn-browse-empty');
  var PAGE=20, shown=PAGE, activeCat='all', q='';
  var CATS={
    signals:['signal','performance','energy','mind','fog','first hour','keeping up'],
    sleep:['sleep','bedtime','rest','circadian','light'],
    stress:['stress','calm','nervous','breath','vagus','adaptation'],
    gutbrain:['gut','brain','microbiome','probiotic','psychobiotic'],
    science:['science','evidence','study','claim','research','backed'],
    ritual:['ritual','routine','habit','foundation','consisten']
  };
  function matches(it){
    var hay=(it.dataset.title+' '+(it.dataset.tags||'')).toLowerCase();
    if(q && hay.indexOf(q)===-1) return false;
    if(activeCat!=='all'){
      var kws=CATS[activeCat]||[];
      var hit=false;
      for(var i=0;i<kws.length;i++){ if(hay.indexOf(kws[i])!==-1){ hit=true; break; } }
      if(!hit) return false;
    }
    return true;
  }
  function apply(){
    var filtered=(q||activeCat!=='all');
    var visible=0;
    items.forEach(function(it){
      var ok=matches(it);
      var show=ok && (filtered || visible<shown);
      if(ok) visible++;
      it.classList.toggle('is-hidden', !show);
    });
    if(emptyEl) emptyEl.hidden = visible>0;
    if(moreBtn) moreBtn.parentElement.hidden = filtered || visible<=shown;
  }
  if(search) search.addEventListener('input',function(){ q=search.value.trim().toLowerCase(); apply(); });
  chips.forEach(function(c){
    c.addEventListener('click',function(){
      chips.forEach(function(x){ x.classList.remove('is-active'); });
      c.classList.add('is-active'); activeCat=c.dataset.cat; apply();
    });
  });
  if(moreBtn) moreBtn.addEventListener('click',function(){ shown+=PAGE; apply(); });
  apply();
})();

/* ==== FAQ page: live search filter (v1.1 row 274) ==== */
(function(){
  var input=document.querySelector('.faq-search');
  if(!input) return;
  var groups=Array.prototype.slice.call(document.querySelectorAll('.faq-page .faq-group'));
  var emptyEl=document.querySelector('.faq-search-empty');
  input.addEventListener('input',function(){
    var q=input.value.trim().toLowerCase();
    var total=0;
    groups.forEach(function(g){
      var vis=0;
      g.querySelectorAll('.faq-item').forEach(function(d){
        var ok=!q || d.textContent.toLowerCase().indexOf(q)!==-1;
        d.hidden=!ok; if(ok) vis++;
      });
      g.hidden = vis===0;
      total+=vis;
    });
    if(emptyEl) emptyEl.hidden = total>0;
  });
})();

/* Sticky cart: options expander (v1.1 rows 12-15 price cards) */
(function(){
  var toggle=document.querySelector('.sc-options-toggle');
  var panel=document.getElementById('sc-options');
  if(!toggle||!panel) return;
  toggle.addEventListener('click',function(){
    var open=!panel.hidden;
    panel.hidden=open;
    toggle.setAttribute('aria-expanded',String(!open));
    toggle.textContent=open?'Options ▾':'Options ▴';
  });
})();
